{
  "name": "@tscircuit/pcb-viewer",
  "version": "1.11.406",
  "main": "dist/index.js",
  "type": "module",
  "repository": {
    "type": "git",
    "url": "https://github.com/tscircuit/pcb-viewer"
  },
  "license": "MIT",
  "scripts": {
    "start": "cosmos",
    "build": "tsup ./src/index.tsx --platform browser --dts --sourcemap --format esm --outDir dist",
    "yalc": "npm run build && yalc push",
    "format": "biome format . --write",
    "format:check": "biome format .",
    "cosmos": "cosmos",
    "cosmos-export": "cosmos-export",
    "test:x-ray-net": "bun run build && bun tests/x-ray-net/run.ts",
    "test:webgpu": "bun run build && bun tests/webgpu/run.ts"
  },
  "files": [
    "dist"
  ],
  "devDependencies": {
    "@biomejs/biome": "^1.9.4",
    "@semantic-release/commit-analyzer": "^9.0.2",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/npm": "^9.0.1",
    "@semantic-release/release-notes-generator": "^10.0.3",
    "@swc/core": "^1.4.12",
    "@tscircuit/circuit-json-util": "^0.0.116",
    "@tscircuit/circuit-json-webgpu": "github:tscircuit/circuit-json-webgpu#be391d903513b8c9e886a06150363e14c8cbe102",
    "@tscircuit/eagle-xml-converter": "^1.0.0",
    "@types/bun": "latest",
    "@types/color": "^3.0.6",
    "@types/node": "18.7.23",
    "@types/react": "19",
    "@types/react-dom": "~19.1.0",
    "@webgpu/types": "^0.1.72",
    "esbuild": "^0.25.2",
    "format-si-unit": "^0.0.12",
    "next": "^14.1.4",
    "pixi.js": "^8.6.6",
    "playwright": "1.63.0",
    "react": "19.1.0",
    "react-cosmos": "7.0.0-beta.4",
    "react-cosmos-plugin-vite": "7.0.0-beta.0",
    "react-dom": "19.1.0",
    "react-use": "^17.4.0",
    "tscircuit": "^0.0.2354",
    "tsup": "^8.0.2",
    "type-fest": "^3.0.0",
    "typescript": "^5.4.4",
    "use-mouse-matrix-transform": "^1.3.4",
    "zod": "^3.23.5"
  },
  "peerDependencies": {
    "react": "*",
    "react-dom": "*",
    "tscircuit": "*"
  },
  "dependencies": {
    "@emotion/css": "^11.11.2",
    "@tscircuit/alphabet": "^0.0.25",
    "@tscircuit/math-utils": "^0.0.36",
    "@vitejs/plugin-react": "^5.0.2",
    "circuit-json": "^0.0.492",
    "circuit-to-canvas": "0.0.131",
    "color": "^4.2.3",
    "react-supergrid": "^1.0.10",
    "react-toastify": "^10.0.5",
    "transformation-matrix": "^2.13.0",
    "zustand": "^4.5.2"
  }
}
